import React, { FC } from "react";
import { ChatAgents } from "../../store/ChatState";
import { ChatMessageBubble } from "../ChatMessageBubble";
import { ChatMessagePart } from "../ChatMessagePart";
import { TypingIndicator } from "../TypingIndicator";

export interface Props {
    readonly agents: ChatAgents;
    readonly textTypingStatusEnabled?: boolean;
}

/**
 * Show the agent is typing (or the bot - for fun)
 */
const TypingStatus: FC<Props> = (props) => {
    const agentsTyping = Object.values(props.agents).filter((agent) => agent.typing);

    return (
        <>
            {agentsTyping.map((agent, index) => {

                const key = agent.user?.nick || `${index}`;
                const displayName = agent.user?.displayName || "Somebody";

                return (
                    <>
                        {!props.textTypingStatusEnabled ? (
                            <div
                                className="chat-msg-container-wrapper"
                                key={`typing-status-${key}`}>
                                <div
                                    key={key}
                                    className="chat-msg-container agent chat-typing-progress">
                                    <ChatMessagePart user={agent.user} showAvatar={true}>
                                        <div className="chat-msg">
                                            <ChatMessageBubble owner="others" hasTail={true}>
                                                <TypingIndicator />
                                            </ChatMessageBubble>
                                        </div>
                                    </ChatMessagePart>
                                </div>
                            </div>
                        ) : (
                            <div key={`typing-status-${key}`} className="chat-msg-agent-typing">{displayName} is typing</div>
                        )}
                    </>
                );
            })}
        </>
    );
};

export default TypingStatus;
